export default __webpack_public_path__ + "static/media/section-4-right.9b00d983.png";